fx.ns("shared.renderers", class ThemeRenderer extends fx.components.VBox {
    
	constructor(data)
	{
        super(data);
    }

    create()
    {
        this.thumbnail = new fx.components.Image(this.data.thumb_square);
        this.text = new fx.components.Text(this.data.name);
        
        this.addChild( this.thumbnail, { width : 180, height : 180});
        this.addChild( this.text, { width : 180, height : 20});
    }

});
